import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false
  },
  getters: {},
  mutations: {
    changeLoading(state, data) {
      state.loading = data
    }
  },
  actions: {
    changeLoading(context, data) {
      context.commit('changeLoading', data)
    }
  },
  modules: {},
});
